import { defineStore } from 'pinia'
import { ref } from 'vue'
import { api } from '@/services/api'

export const useAppConfigStore = defineStore('appConfig', () => {
  const timezone = ref('Asia/Kolkata') // sensible default until fetched

  async function fetchConfig() {
    try {
      const response = await api.get<{ timezone: string }>('/config')
      timezone.value = response.data.timezone
    } catch {
      // keep default
    }
  }

  return { timezone, fetchConfig }
})
